
export interface ValueItem {
  title: string;
  subTitle: string;
  description: string;
}

export interface DataSetConfig {
  subtitle: string;
  title: string;
  data: ValueItem[];
}


export const OUR_VALUES_DATA: ValueItem[] = [
  {
    title: 'Sứ mệnh',
    subTitle: 'Định nghĩa lại giá trị nghệ thuật xăm hình bằng sự chân thật và đam mê.',
    description: 'Tại The Thế Trung Tattoo, chúng tôi tin rằng hình xăm không chỉ là dấu ấn trên da – mà là ngôn ngữ của bản ngã. Sứ mệnh của chúng tôi là phá bỏ định kiến đã bủa vây nghệ thuật xăm hình trong nhiều thế hệ, khẳng định rằng tattoo is true art – một nghệ thuật thể hiện cá tính, tự do và câu chuyện của mỗi con người. Với niềm đam mê và tôn trọng nghệ thuật cơ thể, The Thế Trung Tattoo không chỉ tạo ra tác phẩm, mà kiến tạo nên một văn hoá tattoo chân chính, chuyên nghiệp và đầy tự hào của Việt Nam trên bản đồ thế giới.',
  },
  {
    title: 'Tầm nhìn',
    subTitle: 'Trở thành biểu tượng nghệ thuật xăm quốc tế, nơi tinh hoa và bản sắc Việt được khẳng định.',
    description: 'Chúng tôi hướng tới tương lai nơi The Thế Trung Tattoo được nhắc đến như một biểu tượng nghệ thuật xăm đại diện cho sự tinh tế, chuẩn mực và sáng tạo không giới hạn. Với hơn một thập kỷ kinh nghiệm, chúng tôi không ngừng rèn luyện kỹ năng, nâng tầm kỹ thuật và tư duy nghệ thuật để mang đến những tác phẩm đạt đẳng cấp. Mỗi hình xăm được tạo nên không chỉ bằng kỹ năng mà còn bằng tâm huyết và triết lý nghệ thuật sống động, góp phần khẳng định vị thế của Studio trong cộng đồng tattoo cả nước.',
  },
  {
    title: 'Giá trị cốt lõi',
    subTitle: 'Xây dựng niềm tin bằng kỹ nghệ, sự tận tâm và trách nhiệm trọn đời với từng tác phẩm.',
    description: 'Giá trị của The Thế Trung Tattoo nằm ở sự tận tâm và tôn trọng tuyệt đối dành cho khách hàng. Chúng tôi tin rằng một hình xăm hoàn hảo không chỉ đẹp, mà phải có linh hồn – được tạo nên từ sự thấu hiểu, tư vấn tận tình và kỹ thuật tinh xảo. Mỗi tác phẩm đều phản ánh cá tính độc nhất của người sở hữu và tinh thần nghệ nhân của người tạo tác. Chúng tôi cam kết đặt an toàn, chất lượng và trải nghiệm khách hàng lên hàng đầu – vì mọi tác phẩm mang dấu ấn của The Thế Trung Tattoo đều là một di sản nghệ thuật sống mãi với thời gian.',
  },
];

